module.exports = require("plugin-assets/shared/util");